/* import_devices.icon.svg.js */

module.exports = {
    icon: `
        <svg viewBox="0 0 20 20" preserveAspectRatio="none">
        <g>
            <path class="foreground-gl" d="M19.7,4.2L19.7,4.2L19.7,4.2L19.7,4.2l-3-3.8c0,0,0,0-0.1-0.1l0,0l0,0C16.5,0.1,16.1,0,15.8,0H7.5C6.9,0,6.3,0.6,6.3,1.4
                v0.1l2.4,1.2h5.9v2.4c0,0.8,0.5,1.4,1.2,1.4h1.8v10.8H8.7V12l-1.1,0.5l-1.3,0.6v5.5c0,0.8,0.5,1.4,1.2,1.4h11.3
                c0.6,0,1.2-0.6,1.2-1.4V5.1C20,4.8,19.9,4.5,19.7,4.2z"/>
            <path class="foreground-gl" d="M7.5,8.8l-0.6,1.6L11.7,8c0.5-0.2,0.5-1.1,0-1.4L6.9,4.2l0.6,1.6H6.5H4.1H1.2C0.5,5.9,0,6.5,0,7.2s0.5,1.5,1.2,1.5h3h2.4
                H7.5z"/>
        </g>
        </svg>
`
};
